import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  * {
    font-family: "Warren Text", "Source Sans Pro", sans-serif;
  }
  h1, h2, h3, h4, h5, h6 {
    font-weight: 500;
    font-family: "Warren Display", "Montserrat", sans-serif;
  }

  .ant-btn.ant-btn-primary {
    color: var(--white) !important;
  }

  /** MUI-BUTTON */
  .MuiButton-root {
    text-transform: none !important;
    border-radius: 8px !important;
    box-shadow: none !important;
    &.MuiButton-sizeLarge {
      height: 53px;
    }

    &.MuiButton-containedInherit {
      background-color: var(--velotax-background-color);
      color: var(--velotax-font-color);
    }

    .MuiButton-startIcon,
    .MuiButton-endIcon {
      /* svg {
        fill: var(--velotax-font-color-light);
      } */
    }
  }

  .MuiInputBase-root.MuiFilledInput-root {
    border-radius: 10px;
    border: 1px solid var(--velotax-border-color);
    transition: border-color .2s ease;

    &,
    &:hover,
    &.Mui-focused {
      background-color: var(--background-input);
    }

    &.Mui-focused {
      border-color: var(--border-color-focus);
    }

    &.Mui-error {
      border-color: var(--ant-error-color);
    }

    &.Mui-disabled {
      background-color: var(--ant-info-color-outline);
    }

    :before, :after {
      display: none;
    }
  }
`;
